/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Ticket types supported by the wallet feature. Subset of TicketType - the wallet currently only covers
 * draw and rapid games; other ticket types (INSTANT, FAST_PLAY, UNKNOWN) are out of scope for now. Acts as the
 * discriminator for which family-specific fields on ParsedDrawPanel / WalletPanelDrawOutcome are populated.
 * @export
 */
export const ParsedTicketType = {
    _11184809: '11184809',
    DRAW: 'DRAW',
    RAPID: 'RAPID',
    unknown_default_open_api: '11184809'
} as const;
export type ParsedTicketType = typeof ParsedTicketType[keyof typeof ParsedTicketType];


export function instanceOfParsedTicketType(value: any): boolean {
    for (const key in ParsedTicketType) {
        if (Object.prototype.hasOwnProperty.call(ParsedTicketType, key)) {
            if (ParsedTicketType[key as keyof typeof ParsedTicketType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ParsedTicketTypeFromJSON(json: any): ParsedTicketType {
    return ParsedTicketTypeFromJSONTyped(json, false);
}

export function ParsedTicketTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParsedTicketType {
    return json as ParsedTicketType;
}

export function ParsedTicketTypeToJSON(value?: ParsedTicketType | null): any {
    return value as any;
}

